import { TrainingRequestsDataCollectionFragmentFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { getStatusColor, getStatusLabel } from './statusUtils'

export const getVisualizations = () => [
  {
    type: 'table' as const,
    options: {
      allowColumnReordering: true,
      allowColumnHiding: true,
      columns: [
        {
          label: i18n.t(
            'trainings.training_requests.my_requests.datatable.columns.training_name'
          ),
          width: 200,
          render: (item: TrainingRequestsDataCollectionFragmentFragment) => ({
            type: 'text' as const,
            value: item?.trainingName ?? '-',
          }),
        },
        {
          label: i18n.t(
            'trainings.training_requests.my_requests.datatable.columns.request_date'
          ),
          sorting: 'createdAt' as const,
          render: (item: TrainingRequestsDataCollectionFragmentFragment) => ({
            type: 'text' as const,
            value: item?.createdAt ? dateBackendDateTimeToUI(item.createdAt) : '-',
          }),
        },
        {
          label: i18n.t('trainings.training_requests.requests.datatable.requested_by'),
          render: (item: TrainingRequestsDataCollectionFragmentFragment) => ({
            type: 'person' as const,
            value: {
              firstName: item?.author?.fullName ?? '',
              lastName: '',
              src: item?.author?.avatar ? buildUrl(item.author.avatar) : '',
            },
          }),
        },
        {
          label: i18n.t('trainings.training_requests.requests.datatable.participants'),
          render: (item: TrainingRequestsDataCollectionFragmentFragment) => {
            const participants = (item?.participantsConnection?.nodes ?? []).filter(Boolean)
            const totalCount = item?.participantsConnection?.totalCount ?? 0
            if (participants.length === 0) {
              return { type: 'text' as const, value: '-' }
            }
            const remainingCount = Math.max(totalCount - participants.length, 0)
            return {
              type: 'avatarList' as const,
              value: {
                avatarList: participants.map((p) => ({
                  firstName: p?.fullName ?? '',
                  lastName: '',
                  type: 'person' as const,
                  src: p?.avatar?.url ? buildUrl(p.avatar.url) : '',
                })),
                remainingCount: remainingCount > 0 ? remainingCount : undefined,
              },
            }
          },
        },
        {
          label: i18n.t('trainings.training_requests.requests.datatable.status'),
          render: (item: TrainingRequestsDataCollectionFragmentFragment) => ({
            type: 'status' as const,
            value: {
              status: getStatusColor(item?.status),
              label: getStatusLabel(item?.status),
            },
          }),
        },
      ],
    },
  },
]
